import styled from '@emotion/styled';
import { media, theme } from '@vfit/shared/themes';

import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const Container = styled.div`
  margin-top: ${theme.spacing['2xl']};

  ${media.desktop`
    display: flex;
    justify-content: center;
    text-align: center;

    div {
      text-align: center;
      min-width: 319px;
    }
  `}

  ${media.tablet`
    display: flex;
    justify-content: center;
    text-align: center;

    div {
      text-align: center;
      min-width: 319px;
    }
  `}
`;

export const ButtonContainer = styled.div<{ isApp?: boolean }>`
  div {
    span {
      display: ${({ isApp }) => (isApp ? 'inline-block' : 'inherit')};
      text-transform: ${({ isApp }) => (isApp ? 'lowercase' : 'inherit')};
      font-weight: ${({ isApp }) => (isApp ? theme.typography.fontWeight.regular : 'inherit')};
      font-size: ${({ isApp }) => (isApp ? theme.typography.fontSize.body2 : 'inherit')};
    }
    span::first-letter {
      text-transform: uppercase;
    }
  }
`;

export const Title = styled.p`
  margin: 0;
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-size: ${theme.typography.fontSize.h4};
  line-height: ${theme.typography.lineHeight.h4};
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.lg};
`;
